/**
* DevExpress Dashboard (data-source.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { deserializeArray, ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
import { TypedSerializableModel } from '../serializable-model';
import { CalculatedField } from './calculated-field';
export class DataSource extends TypedSerializableModel {
    constructor(dataSourceJSON = {}, serializer) {
        super(dataSourceJSON, serializer);
        this.hasCalculatedFields = false;
        this.supportDataMembers = false;
        this.hasFilter = false;
        this.calculatedFields = deserializeArray(dataSourceJSON.CalculatedFields, (item) => new CalculatedField(item, serializer));
    }
    getJson() {
        return new ModelSerializer({ useRefs: false }).serialize(this);
    }
    getUniqueNamePrefix() {
        return super._getUniqueNamePrefix();
    }
}
